
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import PopUserContent from '../../../../components/classhour/pop-content/index.vue'
import UserContentCard from '../../../../components/userContentCard/index.vue'
import type { DairyOption } from '@xt/client/entities/course-v2/user-content'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import InfiniteLoading, { type StateChanger } from 'vue-infinite-loading'
import { EnumLoadResult } from '@xt/client/entities/content/controller'

@Observer
@Component({
  components: {
    UserContentCard,
    PopUserContent,
    EmptyStatus,
    InfiniteLoading
  }
})
export default class MyDairy extends Vue {
  @Ref()
  pop: { showPop: (options: DairyOption) => void; hidePop: () => void }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get PageStore() {
    return this.$store.$userContent
  }

  async infiniteHandler($state: StateChanger) {
    const res = await this.PageStore.loadUserDairy()

    if (res === EnumLoadResult.Cancel) {
      console.log('其他异常')
    }

    if (res === EnumLoadResult.Error) {
      $state.error()
    }

    if (res === EnumLoadResult.Loaded) {
      $state.loaded()
    }

    if (res === EnumLoadResult.Complete) {
      if (this.PageStore.dairyList.length > 0) {
        $state.loaded()
      }
      $state.complete()
    }
  }

  async handleLike({ id }: { id: string }) {
    await this.PageStore.likeDairy(id)
  }

  handleClick(id: string) {
    this.pop?.showPop({
      type: 'dairy',
      momentId: id
    })
  }

  handlePopLike(data: { momentId: string }) {
    this.PageStore.onLikeDairy(data.momentId, true)
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
